export default {
  GlobalLanguageDictionary: {
    signout: '退出',
    displaycolumns: '显示列',
    search: '搜索',
    reset: '重置',
    selectall: '全选',
    edit: '编辑',
    adsearch: '高级搜索',
    entrymanagement: '入职管理',
    onthejob: '在职',
    ontrial: '试用',
    toleave: '待离职',
    leaving: '离职中',
    leave: '离职',
    onthejoball: '在职（全部）',
    staffmanagement: '员工管理',
    cardprinting: '工牌打印',
    entryprinting: '入职打印',
    repairprinting: '补打印',
    printinghistory: '工牌历史打印记录',
    printpreview: '打印预览',
    noheadprint: '无头像打印',
    printrecordexport: '打印记录导出',
    bankcardmanagement: '银行卡管理',
    employmentmanagement: '转正管理',
    tobecomemember: '入职待转正',
    promotionmember: '晋升待转正',
    hasmemember: '入职已转正',
    regularmemember: '晋升已转正',
    contractmanagement: '合同管理',
    tobesigned: '待签订',
    agreementtobesigned: '协议待签订',
    torenew: '待续签',
    signed: '已签订',
    agreementsigned: '协议已签订',
    changemanagement: '异动管理',
    leaveoffice: '离职流程',
    applyleavelist: '申请离职名单',
    inprocess: '处理中',
    completed: '已完成',
    datamanagement: '数据管理',
    locationinformation: '地址信息',
    company: '公司',
    organization: '组织机构',
    post: '岗位',
    positionname: '职位',
    performanceappraisal: '绩效考核',
    performanceappraisaldetails: '绩效考核详情',
    jobdescription: '岗位说明书',
    jobdescriptiondetails: '岗位说明书详情',
    jobdescriptionduty: '岗位说明书职责',
    positionlevel: '职级',
    dictionaries: '字典',
    accesscontrol: '门禁管理',
    paycard: '刷卡管理',
    permission: '权限取消',
    pleaseenter: '请输入',
    pleasechoose: '请选择',
    startdate: '开始日期',
    enddate: '结束日期',
    to: '至',
    filename: '文件名',
    sheetname: '工作表名称',
    exportdatatype: '导出数据类型',
    exportcolumns: '导出列',
    allcurrent: '当前过滤条件全部数据',
    selectdata: '选中数据',
    selectdatause: '选中数据（勾选数据后使用）',
    currentpagedata: '当前页数据',
    alldata: '所有数据',
    printing: '打印',
    seldataop: '请选择要操作的数据',
    nodata: '暂无数据',
    incorrectinformation: '信息填写有误',
    and: '并且',
    or: '或者',
    equal: '等于',
    notEqual: '不等于',
    less: '小于',
    lessorequal: '小于等于',
    greater: '大于',
    greaterorequal: '大于等于',
    startswith: '开始于',
    endswith: '结束于',
    contains: '包含',
    notContains: '不包含',
    in: '包括在',
    notin: '不包括在',
    suretodelete: '确定删除吗?',
    openoaaccount: '开通OA账号',
    back: '返回',
    backhome: '返回首页',
    keywordsfilter: '输入关键字进行过滤',
    selectbatchedit: '选择批量编辑字段',
    viewhistoryprint: '查看历史打印',
    sumbit: '提交',
    confirm: '确认',
    details: '详情',
    withdrawalofresignation: '离职撤销',
    makedeparture: '自离补办',
    inputjobnumber: '输入工号，多个工号用,隔开',
    duty: '职责',
    addgrouping: '添加分组',
    addconditions: '添加条件',
    add: '新增',
    undo: '撤销',
    save: '保存',
    delete: '删除',
    enter: '确定',
    cancel: '取消',
    export: '导出',
    batchinduction: '批量入职',
    inservice: '已入职',
    audit: '审核',
    batchaudit: '批量审核',
    downloadtemplate: '下载模板',
    import: '导入',
    batchchange: '批量异动',
    alreadychanged: '已异动',
    batchsubmission: '批量提交',
    batchconfirmation: '批量确认',
    jobnumberimport: '工号导入',
    importemployeephone: '导入员工手机号',
    workno: '工号',
    entrydate: '入职日期',
    personname: '姓名',
    idcard: '身份证',
    employmenttype: '雇佣类型',
    starttime: '起始时间',
    laborcontractsigner: '劳动合同签署方',
    encode: '编码',
    designation: '名称',
    legalpersonnumber: '法人编号',
    legalpersonname: '法人名称',
    superiorno: '上级编号',
    organizationno: '组织编号',
    organizationname: '组织名称',
    positionnumber: '职位编号',
    rankname: '职级名称',
    dictionarytype: '字典类型',
    dictionarynumber: '字典编号',
    dictionaryname: '字典名称',
    postnumber: '岗位编号',
    postname: '岗位名称',
    secondaryagent: '二级代理',
    thirdlevelagency: '三级代理',
    leavedate: '离职日期',
    sincereissuedate: '自离补办日期',
    certificatenumber: '证件号',
    effectivedate: '日期',
    check: '勾选',
    operation: '操作',
    employeeinformationdetails: '员工信息详情',
    employmentinformation: '雇佣信息',
    resignationinformation: '离职信息',
    personalinformation: '个人信息',
    contactinformation: '联系信息',
    ducationalexperience: '教育经历',
    workexperience: '工作经历',
    identityinformation: '身份信息',
    becomeinformation: '转正信息',
    salaryinformation: '工资信息',
    employeejobnumber: '员工工号',
    firstworkingdate: '首次工作日期',
    agedate: '司龄日期',
    employmentstatus: '雇佣状态',
    typesofemployment: '雇佣类型',
    employeecharacteristics: '员工特性',
    sourceofemployeeresume: '员工简历来源',
    sourcenote: '来源备注',
    generalcontractor: '总包',
    occupationtype: '职业类型',
    salarycalculationemployeetype: '薪资计算员工类型',
    lengthofservice: '公司工龄(年)',
    companyemail: '公司邮箱',
    typesofsocialsecurity: '参加社保类型',
    agreementdeduction: '协议扣款',
    iccard: 'IC卡',
    actualconfirmationdate: '转正日期',
    trialenddate: '试用结束日期',
    probationcontractsalary: '试用期基本工资',
    probationpostsalary: '试用期岗位工资',
    probationbonussalary: '试用奖金',
    becomecontractsalary: '转正后基本工资',
    becomepostsalary: '转正后岗位工资',
    becomebonussalary: '转正后奖金',
    leavereasontype: '离职原因类别',
    leavereason: '离职原因',
    personneldeduction: '人事扣款金额',
    isbackshoekey: '是否归还鞋柜钥匙',
    isbackphonetag: '是否归还手机标签',
    isbackworkclothesshoes: '是否归还工服工鞋',
    deductionworkclothesshoesmoney: '扣款工服工鞋金额',
    isbackdormitorykey: '是否归还宿舍钥匙',
    deductiondormitorykeymoney: '扣款宿舍钥匙金额',
    isbackbrand: '是否归还厂牌',
    deductionbrandmoney: '扣款厂牌金额',
    postregistrationdeduction: '自离补办扣款',
    essentialinformation: '基本信息',
    nationality: '国籍',
    cardtype: '证件类型',
    idcardnum: '身份证号',
    validbegindate: '身份证有效开始日期',
    validenddate: '身份证有效结束日期',
    signagency: '签发机关',
    name: '姓名',
    birth: '出生年月',
    age: '年龄',
    birthaddress: '籍贯',
    nodeType: '户口类型',
    englishname: '英文名',
    maritalstatus: '婚姻状况',
    sex: '性别',
    politicsstatus: '政治面貌',
    ethnic: '民族',
    isdisabled: '残障人士',
    equipmentphoto: '员工头像',
    contactmode: '联系方式',
    addressinformation: '地址信息',
    contactpeopleinformation: '联系人信息',
    countrycode: '国家/地区/代码',
    phone: '手机号码',
    email: '个人邮箱',
    province: '省/直辖市',
    currentaddress: '详细地址',
    zipcode: '邮编',
    emergencyperson: '姓名',
    emergencyrelation: '与员工关系',
    emergencycontact: '手机号码',
    isemergency: '是否紧急联系人',
    graduateschool: '毕业院校',
    professional: '专业',
    educationnature: '学历性质',
    education: '学历',
    educationstartdate: '受教育开始日期',
    educationenddate: '受教育结束日期',
    certificateno: '毕业证书编码',
    academicdegreeno: '学位证书编码',
    ishighesteducation: '是否最高学历',
    certificateimage: '毕业证书图片',
    academicdegreeimage: '学位证书图片',
    workunit: '工作单位名称',
    workpost: '职位名称',
    worktimefrom: '工作开始日期',
    worktimeto: '工作结束日期',
    reasonleaving: '离职原因',
    provename: '证明人',
    provephone: '证明人手机号码',
    upload: '上传',
    clickupload: '点击上传',
    filemanagement: '档案管理',
    file: '文件',
    abnormalState: '异动状态',
    version: '版本',
    newfeatures: '新特性',
    bug: 'BUG',
    optimization: '优化',
    submittedon: ' 提交于',
    articles: '新闻管理',
    title: '标题',
    type: '分类',
    exitnail: '退出钉钉',
    synchronizationcardnumber: '同步卡号',

    //新
    dashboard:'表格模板',
    systemlogin: '系统登录',
    login: '登 录',
    rememberpwd: '记住密码',
    entername:'请输入用户名',
    enterpwd:'请输入密码',
    loginsuccess:'登录成功',
    loginout:'退出登录',
    companyname: '公司名称',
    username:'用户名',
    password: '密码',
    prompt: '提示',
    changepwd: '修改密码',
    oldpwd: '原密码',
    newpwd: '新密码',
    confirmpwd: '确认密码',
    enteroldpwd: '请输入原密码！',
    oldpwdwrong: '原密码错误！',
    enternewpwd: '请输入新密码！',
    regnewpwd: '请输入长度8-30位，包含英文大小写、数字、特殊符号的密码！',
    enterfirmpwd: '请确认密码！',
    enterconpwd: '两次输入的密码不相同！',
    isolateselect: '数据隔离选择',
    // 系统名称
    HRMS: '制造人事系统',
    Attendance: '制造考勤系统',
    HRMS_India: '印度制造人事系统',
    MainSystem: '主系统',
    HrRecruit: '制造招聘系统',
    FatoryAccess: '工厂门禁系统',
    Attendances: '制造考勤机系统',
    Course: '制造培训系统',
    CarAppoint: '车辆预约系统',
    paperless: '制造无纸化系统',
    Paperless: '制造无纸化系统',
    EMS: '设备管理系统',
    SZHRMS: '深圳人事系统',
    CourseQC: '深圳培训系统',
    SalaryManagement: '制造薪酬系统',
    AuditAttendance: '制造闻泰考勤系统(稽核)',
    FactoryGuard: '制造工厂门禁系统',
    NewProperty: '制造物业管理系统',
    ComplianceAttendance: '合规考勤',
    Salary: '薪酬系统(工资条)',
    EarlyWarn: '预警系统',
    AttendanceIndia: '制造考勤系统（印度版）',
    HRMSIT: 'IT人事系统',
    FactoryGuardTwo: '制造整机门禁系统',
    DLCost: '制造成本预算&DL费用管理',
  }
}
